export enum CartOperation {
    GETCART = 'getCart',
    ADDUPSELL = 'addUpsell',
    ADDACCESSORY = 'addAccessory',
    ADDMANUAL = 'addManual',
    ADDCOUPON = 'addCoupon',
    REMOVEITEM = 'removeItem',
    REMOVEMANUAL = 'removeManual',
    REMOVECOUPON = 'removeCoupon',
    UPDATEQUANTITY = 'updateQuantity',
    VALIDATECOUPON = 'validateCoupon',
    SAVECUSTOMFIELD = 'saveCustomField',
    ORDERDETAILS = 'orderDetails',
    UPDATECART = 'updateCart',
    APPLYCOUPON = 'applyCoupon',
    SKIPAPPLYCOUPON = 'skipApplyCoupon',
    REORDER = 'reorder',
    UPDATE_ANONYMOUS_ID = 'updateAnonymoudId',
}